<template>
  <v-row no-gutters>
    <v-col>
      <div id="user-list" :class="{ 'page-fullscreen': pageStore.isFullScreen }">
        <v-card tile :class="$vuetify.breakpoint.mdAndDown ? null : 'rounded-t-xl'">
          <PageHeader>
            <template #action>
              <v-dialog
                v-model="addEditdialog"
                max-width="500px"
                class="elevation-0"
                scrollable
                :persistent="dialogLoading"
                overlay-opacity="0.6"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="userData.role === 'COMMAN'"
                    v-bind="attrs"
                    v-on="on"
                    class="text-capitalize"
                    color="secondary"
                    depressed
                    rounded
                  >
                    Kullanıcı Ekle
                  </v-btn>
                </template>

                <v-card
                  rounded="xl"
                  flat
                  :disabled="dialogLoading"
                  :class="{
                    'scrollable-card': !isScroll,
                    'scrollable-text-card': !isScroll && $vuetify.breakpoint.mdAndDown,
                    'scrollable-not-card': !isScroll && arrivedState.bottom,
                  }"
                >
                  <v-card-title class="grey">
                    <h4 class="text-body-1 text-sm-h6 font-weight-bold">
                      {{ addEditFormTitle }}
                    </h4>

                    <v-spacer />

                    <v-btn
                      color="error"
                      small
                      outlined
                      class="mx-4 text-capitalize"
                      rounded
                      v-if="
                        editedIndex > -1 &&
                        userData.role === 'COMMAN' &&
                        editedItem.member_profile === 'COMUSR'
                      "
                      :loading="deleteLoading"
                      @click="deleteItem()"
                    >
                      <v-icon left>{{ icons.mdiTrashCan }}</v-icon> Sil
                    </v-btn>
                    <v-btn
                      v-if="$vuetify.breakpoint.smAndUp"
                      rounded
                      small
                      depressed
                      color="chip"
                      class="text-capitalize"
                      @click="closeItem"
                    >
                      <v-icon left>{{ icons.mdiClose }}</v-icon>
                      Kapat
                    </v-btn>
                    <v-icon v-else small @click="closeItem">{{ icons.mdiClose }}</v-icon>
                  </v-card-title>

                  <v-divider />
                  <v-card-text
                    ref="scrollableEl"
                    class="pa-0 pa-sm-3 pb-0 pt-3"
                    style="height: 80dvh"
                    :style="
                      !$vuetify.breakpoint.smAndUp ? 'max-height: 485px' : 'max-height: 615px'
                    "
                  >
                    <validation-observer ref="form">
                      <v-container class="pb-0">
                        <v-row>
                          <v-col cols="12" md="12" v-if="userData.role !== 'COMMAN'">
                            <validation-provider name="Profil"
                              v-slot="{ errors }"
                              tag="div"
                              mode="eager"
                              rules="required"
                            >
                              <v-select
                                v-model="editedItem.member_profile"
                                :items="profileList"
                                disabled
                                label="Profil"
                                rounded
                                filled
                                hide-details
                                :error-messages="errors"
                              />
                            </validation-provider>
                          </v-col>
                          <v-col cols="12" md="6" v-if="editedIndex === -1">
                            <validation-provider name="Cari Kod"
                              v-slot="{ errors }"
                              tag="div"
                              mode="eager"
                              rules="required"
                            >
                              <v-text-field
                                :error-messages="errors"
                                v-model="editedItem.cari_kod"
                                label="Cari Kod"
                                rounded
                                filled
                                hide-details
                              />
                            </validation-provider>
                          </v-col>
                          <v-col cols="12" md="6" v-if="editedIndex === -1">
                            <validation-provider name="Adres Numarası"
                              v-slot="{ errors }"
                              tag="div"
                              mode="eager"
                              rules="required"
                            >
                              <v-text-field
                                :error-messages="errors"
                                v-model="editedItem.adrnums"
                                label="Adres Numarası"
                                rounded
                                filled
                                hide-details
                              />
                            </validation-provider>
                          </v-col>
                          <v-col cols="12" md="6" v-if="editedIndex === -1">
                            <validation-provider name="Ad"
                              v-slot="{ errors }"
                              tag="div"
                              mode="eager"
                              rules="required"
                            >
                              <v-text-field
                                :error-messages="errors"
                                v-model="editedItem.ad"
                                label="Ad"
                                rounded
                                filled
                                hide-details
                              />
                            </validation-provider>
                          </v-col>
                          <v-col cols="12" md="6" v-if="editedIndex === -1">
                            <validation-provider name="Soyad"
                              v-slot="{ errors }"
                              tag="div"
                              mode="eager"
                              rules="required"
                            >
                              <v-text-field
                                :error-messages="errors"
                                v-model="editedItem.soyad"
                                label="Soyad"
                                rounded
                                filled
                                hide-details
                              />
                            </validation-provider>
                          </v-col>
                          <v-col cols="12" md="6">
                            <validation-provider name="E-Posta"
                              v-slot="{ errors }"
                              tag="div"
                              mode="eager"
                              rules="email"
                            >
                              <v-text-field
                                :error-messages="errors"
                                v-model="editedItem.mail"
                                label="E-Posta"
                                type="email"
                                rounded
                                filled
                                hide-details
                              />
                            </validation-provider>
                          </v-col>
                          <v-col cols="12" md="6">
                            <validation-provider name="Telefon" v-slot="{ errors }" tag="div" mode="eager">
                              <v-text-field
                                :error-messages="errors"
                                v-model="editedItem.telnum"
                                label="Telefon"
                                rounded
                                filled
                                hide-details
                              />
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <v-row v-if="editedItem.member_profile === 'SUBE'">
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="editedItem.cashform_branch_name"
                              label="Şube Adı"
                              rounded
                              filled
                              hide-details
                            />
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="editedItem.cashform_account"
                              label="100'lu Hesap"
                              rounded
                              filled
                              hide-details
                            />
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="editedItem.persid"
                              label="Personel Sicil Numarası"
                              rounded
                              filled
                              hide-details
                            />
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="editedItem.costcenter"
                              label="Masraf Merkezi"
                              rounded
                              filled
                              hide-details
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <validation-provider name="Kullanıcı Adı"
                              v-slot="{ errors }"
                              tag="div"
                              mode="eager"
                              rules="required"
                            >
                              <v-text-field
                                :error-messages="errors"
                                v-model="editedItem.username"
                                label="Kullanıcı Adı"
                                rounded
                                filled
                                hide-details
                              />
                            </validation-provider>
                          </v-col>
                          <v-col cols="12">
                            <validation-provider name="Şifre"
                              v-slot="{ errors }"
                              tag="div"
                              mode="eager"
                              :rules="editedIndex > -1 ? '' : 'required'"
                            >
                              <v-text-field
                                @click:append="showPassword = !showPassword"
                                :error-messages="errors"
                                v-model="editedItem.sifre"
                                :append-icon="showPassword ? icons.mdiEye : icons.mdiEyeOff"
                                :type="showPassword ? 'text' : 'password'"
                                :label="editedIndex > -1 ? '' : 'Şifre'"
                                :placeholder="
                                  editedIndex > -1 ? 'Şifre değiştirmek için doldurun' : ''
                                "
                                autocomplete="new-password"
                                rounded
                                filled
                                hide-details
                            /></validation-provider>
                          </v-col>
                          <v-col v-if="!$vuetify.breakpoint.smAndUp">
                            <v-switch
                              v-model="editedItem.aktif"
                              class="mt-0 pt-0 ml-3"
                              inset
                              color="secondary"
                              :label="
                                editedItem.aktif
                                  ? 'Kullanıcı Durumu Aktif'
                                  : 'Kullanıcı Durumu Pasif'
                              "
                            ></v-switch>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-textarea
                              v-model="editedItem.emailto"
                              label="E-Posta TO"
                              rows="3"
                              rounded
                              class="rounded-xl"
                              filled
                              hide-details
                            />
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-textarea
                              v-model="editedItem.emailcc"
                              label="E-Posta CC"
                              rows="3"
                              rounded
                              class="rounded-xl"
                              filled
                              hide-details
                            />
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-textarea
                              v-model="editedItem.emailbcc"
                              label="E-Posta BCC"
                              rows="3"
                              rounded
                              class="rounded-xl"
                              filled
                              hide-details
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </validation-observer>
                  </v-card-text>
                  <v-card-actions class="pa-0 pa-sm-3 pt-0">
                    <v-container class="pt-0" style="z-index: 2">
                      <v-row align="center">
                        <v-col cols="12" :sm="editedIndex > -1 ? 7 : 12">
                          <v-btn
                            color="secondary"
                            depressed
                            rounded
                            block
                            x-large
                            :loading="saveLoading"
                            class="text-capitalize"
                            @click="saveItem()"
                          >
                            {{ editedIndex > -1 ? "Güncelle" : "Kaydet" }}
                          </v-btn>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="5"
                          v-if="editedIndex > -1 && $vuetify.breakpoint.smAndUp"
                        >
                          <v-switch
                            v-model="editedItem.aktif"
                            hide-details
                            class="mt-0 pt-0 ml-3"
                            inset
                            color="secondary"
                            :label="editedItem.aktif ? 'Aktif' : 'Pasif'"
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
          </PageHeader>

          <v-data-table
            :headers="tableColumns"
            :items="tableItems"
            :loading="tableLoading"
            loader-height="2"
            :mobile-breakpoint="100"
            fixed-header
            hide-default-footer
            :height="pageStore.tableHeight"
            :options.sync="tableOptions"
            :server-items-length="tableTotalRec"
            :disable-items-per-page="true"
            :items-per-page="20"
          >
            <!-- Load More -->
            <template #[`body.append`] v-if="loadMoreLoading">
              <tr>
                <td :colspan="tableColumns.length">
                  <div class="text-center" v-intersect.quiet="loadMore">
                    <v-progress-circular
                      v-if="tableItems.length > 0"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </td>
              </tr>
            </template>

            <!-- Arama Alanı -->
            <template #[`body.prepend`]>
              <tr class="data-table-body-search">
                <!-- Durum -->
                <td class="pa-0">
                  <v-select
                    v-model="tableSearchStatus"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    :items="[
                      { text: 'Aktif', value: '1' },
                      { text: 'Pasif', value: '0' },
                    ]"
                    placeholder="Ara"
                    filled
                    clearable
                    class="rounded-0 elevation-0"
                    hide-details
                    attach
                    :menu-props="{ bottom: true, offsetY: true }"
                  />
                </td>

                <!-- Sipariş No -->
                <td class="pa-0">
                  <v-select
                    v-model="tableSearchProfile"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    :items="[
                      { text: 'Bayi', value: 'BAYI' },
                      { text: 'Şube', value: 'SUBE' },
                      { text: 'Catreing', value: 'COMUSR' },
                      { text: 'Kurumsal', value: 'COMM' },
                      { text: 'Tedarikçi', value: 'VNDR' },
                    ]"
                    placeholder="Ara"
                    filled
                    clearable
                    class="rounded-0 elevation-0"
                    hide-details
                    attach
                    :menu-props="{ bottom: true, offsetY: true }"
                  />
                </td>

                <td class="pa-0">
                  <v-text-field
                    v-model="tableSearchUsername"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    clearable
                    placeholder="Ara"
                    filled
                    class="rounded-0 elevation-0"
                    hide-details
                  />
                </td>
                <td class="pa-0">
                  <v-text-field
                    v-model="tableSearchCustomer"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    clearable
                    placeholder="Ara"
                    filled
                    class="rounded-0 elevation-0"
                    hide-details
                  />
                </td>

                <td class="pa-0">
                  <div class="d-flex">
                    <v-text-field
                      v-model="tableSearchRootno"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="No"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                    <v-text-field
                      v-model="tableSearchSira"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="Sıra"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                  </div>
                </td>
                <!-- Boş -->
                <td class="pa-0">
                  <v-text-field filled disabled class="rounded-0 elevation-0" hide-details />
                </td>
                <td class="pa-0">
                  <v-text-field filled disabled class="rounded-0 elevation-0" hide-details />
                </td>
              </tr>
            </template>

            <!-- Durum -->
            <template #[`item.aktif`]="{ item }">
              <v-chip
                label
                outlined
                class="d-flex justify-center"
                :color="item.aktif ? 'success' : 'warning'"
              >
                <span style="font-size: 11px !important; letter-spacing: 0.5px">
                  {{ item.aktif ? "Aktif" : "Pasif" }}</span
                >
              </v-chip>
            </template>

            <!-- Cari Tip -->
            <template #[`item.member_Txt`]="{ item }">
              <v-tooltip color="chip" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    label
                    :color="memberProfile(item.member_Txt)"
                    class="d-flex justify-center cari-tip-chip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div class="cari-tip-text text-uppercase">
                      {{ item.member_Txt }}
                    </div>
                  </v-chip>
                </template>
                <div class="text-caption">
                  {{ item.member_Txt }}
                </div>
              </v-tooltip>
            </template>

            <!-- Kullanıcı Adı -->
            <template #[`item.username`]="{ item }">
              <v-chip class="d-flex justify-center" color="#28243D" label>
                <div
                  class="text-truncate"
                  style="
                    width: 120px !important;
                    text-align: center;
                    font-size: 11px !important;
                    letter-spacing: 0.5px;
                    color: azure;
                  "
                >
                  {{ item.username }}
                </div>
              </v-chip>
            </template>

            <!-- Cari Unvan -->
            <template #[`item.name1`]="{ item }">
              <div class="text-truncate" style="max-width: 600px !important">
                <div class="text-caption text-lg-subtitle-2 white--text">
                  {{ item.name1 }}
                </div>
                <div class="text-caption text--secondary mt-1" v-if="item.address">
                  {{ item.address }} - {{ item.adrnums }}
                </div>
                <div
                  class="primary--text d-flex"
                  style="font-size: 12px !important; line-height: 1.5"
                >
                  <div class="mr-5 d-flex align-center">
                    <v-icon size="16" class="mr-1">{{ icons.mdiQrcode }}</v-icon>
                    <span>
                      {{ item.cari_kod }}
                    </span>
                  </div>
                  <a
                    :href="`tel:${item.telnum}`"
                    v-if="item.telnum"
                    class="mr-5 text-decoration-none"
                  >
                    <v-icon size="16" class="mr-1">{{ icons.mdiPhoneDial }}</v-icon>
                    {{ phoneNumberFormatView(item.telnum) }}
                  </a>
                  <a :href="`mailto:${item.mail}`" v-if="item.mail" class="text-decoration-none"
                    ><v-icon size="16" class="mr-1">{{ icons.mdiEmail }}</v-icon
                    >{{ item.mail }}</a
                  >
                </div>
              </div>
            </template>

            <!-- Root Bilgisi -->
            <template #[`item.esmroute`]="{ item }">
              <v-chip
                :color="rootInfo(item.esmroute, item.esmrouteseq)[0] ? 'grey' : '#9391a2'"
                :outlined="!rootInfo(item.esmroute, item.esmrouteseq)[0]"
                class="d-flex justify-center"
                label
              >
                <div
                  class="text-uppercase"
                  style="text-align: center; font-size: 11px !important"
                  v-html="rootInfo(item.esmroute, item.esmrouteseq)[1]"
                />
              </v-chip>
            </template>

            <!-- Son Giriş Tarihi -->
            <template #[`item.son_giris`]="{ item }">
              <v-tooltip color="chip" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip color="" class="d-flex justify-center" label v-bind="attrs" v-on="on">
                    <div
                      class="text-truncate d-flex align-center"
                      style="
                        width: 140px !important;
                        text-align: center;
                        font-size: 11px !important;
                        letter-spacing: 0.5px;
                        color: azure;
                      "
                    >
                      <v-icon color="" small class="mr-2">
                        {{ icons.mdiCalendarClock }}
                      </v-icon>
                      <div class="mr-1">
                        {{ item.son_giris | moment("DD.MM.YYYY ") }}
                      </div>

                      <span> - {{ item.son_giris | moment("HH:mm") }}</span>
                    </div>
                  </v-chip>
                </template>
                <div>
                  <timeago :datetime="item.son_giris"></timeago>
                </div>
              </v-tooltip>
            </template>

            <template #[`item.actions`]="{ item }">
              <v-btn
                depressed
                block
                style="height: 32px !important"
                color="chip"
                class="text-capitalize ml-2"
                @click="editItem(item)"
              >
                Düzenle
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { onMounted, computed, watch, ref, onUnmounted } from "vue-demi";

// Pinia

import { usePageStore } from "@/stores/pageHeader";

// Plugin
import { useToast } from "vue-toastification/composition";

// Unit
import { useDebounceFn, useScroll, useResizeObserver } from "@vueuse/core";
import { postData } from "@utils";

// Components
import PageHeader from "@/components/PageHeader/Index.vue";
import AddEdit from "./AddEdit.vue";

// Icons
import {
  mdiCamera,
  mdiCameraOff,
  mdiClose,
  mdiAccountTie,
  mdiMagnify,
  mdiUpload,
  mdiTrashCan,
  mdiCalendarClock,
  mdiPhoneDial,
  mdiQrcode,
  mdiEmail,
} from "@mdi/js";

export default {
  components: {
    PageHeader,
    AddEdit,
  },
  setup() {
    // Pinia

    const pageStore = usePageStore();
    const userData = JSON.parse(localStorage.getItem("userData"));
    const scrollableEl = ref(null);

    // Kaydırma çubuğu
    const { arrivedState } = useScroll(scrollableEl);
    const isScroll = ref(false);
    onMounted(() => {
      isScroll.value = scrollableEl.value?.scrollHeight === scrollableEl.value?.offsetHeight;
    });

    // Ekran boyutu algılama
    useResizeObserver(scrollableEl, (entries) => {
      isScroll.value = scrollableEl.value?.scrollHeight === scrollableEl?.value.offsetHeight;
    });

    const form = ref(null);
    const dialogLoading = ref(false);
    const editedIndex = ref(-1);
    const editedItem = ref({
      aktif: true,
      cari_kod: "",
      mail: "",
      telnum: "",
      adrnums: "",
      ad: "",
      soyad: "",
      username: "",
      address: "",
      sifre: "",
      sifret: "",
      mail_check: 1,
      sifre_check: 1,
      cashform_branch_name: "",
      cashform_account: "",
      persid: "",
      costcenter: "",
    });

    const defaultItem = JSON.parse(JSON.stringify(editedItem.value));

    const saveItem = async () => {
      ["mail", "username", "sifre"].forEach((k) => {
        if (typeof editedItem.value[k] === "string")
          editedItem.value[k] = editedItem.value[k].trim();
      });
      const isValid = await form.value.validate();

      // Form Kontrol
      if (!isValid) {
        const messages = Object.values(form.value.errors || {})
          .flat()
          .filter(Boolean);
        toast.error(["Lütfen kırmızı alanları doldurun", ...messages].join("\n"), {
          position: "bottom-center",
        });

        return;
      }
      dialogLoading.value = true;

      delete editedItem.value.name1;
      delete editedItem.value.esmroute;
      delete editedItem.value.esmrouteseq;
      delete editedItem.value.son_giris;
      delete editedItem.value.member_Txt;

      try {
        saveLoading.value = true;
        if (editedIndex.value > -1) {
          if (editedItem.value.sifre) {
            editedItem.value.sifret = editedItem.value.sifre;
            editedItem.value.sifre_check = 1;
          }
          editedItem.value.mode2 = "memberUpdate";

          const response = await postData({
            method: "insertMember",
            ...editedItem.value,
          });
          if (response.error) {
            throw new Error(response.msg);
          }

          toast.info(`"${editedItem.value.username}" Kullanıcısı güncellendi`);
        } else {
          editedItem.value.sifret = editedItem.value.sifre;
          editedItem.value.member_profile = "COMUSR";

          const response = await postData({
            method: "insertMember",
            ...editedItem.value,
          });
          if (response.error) {
            throw new Error(response.msg);
          }

          toast.success(`"${editedItem.value.username}" Kullanıcısı eklendi`);
        }
        tableItems.value = [];
        tableFetch();
      } catch (e) {
        toast.error(`Hata ${e}`, { position: "bottom-center" });
        return;
      } finally {
        closeItem();
      }
    };
    const showPassword = ref(false);

    // Ekle / Düzenle / Sil
    const addEditdialog = ref(false);
    const deleteLoading = ref(false);
    const saveLoading = ref(false);
    const addEditFormTitle = computed(() => {
      return editedIndex.value === -1 ? "Kullanıcı Ekle" : "Düzenleme";
    });

    const editItem = (item) => {
      editedIndex.value = tableItems.value.indexOf(item);
      editedItem.value = Object.assign({}, item);
      addEditdialog.value = true;
    };

    const deleteItem = async () => {
      Vue.swal({
        title: "Emin misin",
        html: `<strong>"${editedItem.value.username}"</strong><br>kullanıcı silinsin mi`,
        icon: "warning",
        width: "350px",
        background: "#FF4C51",
        showCancelButton: true,
        confirmButtonColor: "#cc3d41",
        confirmButtonText: "Evet",
        cancelButtonText: "Vazgeç",
        cancelButtonColor: "#FF4C51",
      }).then(async (result) => {
        if (result.isConfirmed) {
          dialogLoading.value = true;
          deleteLoading.value = true;
          try {
            const response = await postData({
              method: "deleteMember",
              id: editedItem.value.uid,
            });
            if (response.error) {
              throw new Error(response.msg);
            }
            toast.warning(`"${editedItem.value.username}" kullanıcı silindi`);
            tableFetch();
          } catch (e) {
            toast.error(`Hata ${e}`, { position: "bottom-center" });
          } finally {
            closeItem();
          }
        }
      });
    };

    const closeItem = () => {
      dialogLoading.value = false;
      deleteLoading.value = false;
      saveLoading.value = false;
      addEditdialog.value = false;
      editedItem.value = Object.assign({}, defaultItem);
      editedIndex.value = -1;
    };

    watch(
      () => addEditdialog,
      (val) => {
        if (!val) {
          form.value.reset();
        } else {
        }
      }
    );
    // Sayfa Özellikleri
    const pageSettings = () => {
      pageStore.pageTitle = "Kullanıcılar";
      pageStore.pageIcon = mdiAccountTie;
      pageStore.hasFullScreen = true;
      pageStore.hasDownload = true;
      pageStore.hasDateRangeAll = false;
      pageStore.hasDateRange = false;
      pageStore.hasActions = true;

      pageStore.downloadHeader = {
        Durum: "aktif",
        "Cari Tip": "member_Txt",
        "Kullanıcı Adı": "username",
        "Cari Unvan": "name1",
        "Root No": "esmroute",
        "Root Sıra": "esmrouteseq",
        "Son Giriş Tarihi": "son_giris",
      };
    };

    const toast = useToast();

    // Table
    const tableLoading = ref(true);
    const tableItems = ref([]);
    const tableTotalRec = ref(0);

    // Table Columns
    const tableColumns = ref([
      {
        text: "Durum",
        value: "aktif",
        align: "left px-4 px-lg-3",
        width: "90",
        sortable: false,
      },
      {
        text: "Cari Tip",
        value: "member_Txt",
        align: "left pl-0 pr-3 px-lg-3",
        sortable: false,
        width: "180px",
      },

      {
        text: "Kullanıcı Adı",
        value: "username",
        align: "left pl-0 pr-3 px-lg-3",
        sortable: false,
        width: "120",
      },
      {
        text: "Cari Unvan",
        align: "left pl-0 pr-3 px-lg-3",
        value: "name1",

        sortable: false,
      },

      {
        text: "Root Bilgisi",
        align: "center pl-0 pr-3 px-lg-3",
        value: "esmroute",
        width: "120px",
        sortable: false,
      },
      {
        text: "Son Giriş Tarihi",
        align: "center pl-0 pr-3 px-lg-3",
        value: "son_giris",
        width: "130px",
        sortable: false,
      },
      {
        text: "",
        align: "right pl-0 pr-6",
        value: "actions",
        width: "80px",
        sortable: false,
      },
    ]);

    // Table Load More
    const tablePage = ref(1);
    const loadMoreLoading = ref(false);
    const loadMore = (isIntersecting) => {
      if (isIntersecting) {
        tablePage.value++;
        tableOptions.value.page = tablePage.value;
        if (!tableLoading.value) {
          tableFetch();
        }
      }
    };

    // Tablo Arama
    const tableSearchStatus = ref("");
    const tableSearchProfile = ref("");
    const tableSearchUsername = ref("");
    const tableSearchCustomer = ref("");
    const tableSearchRootno = ref("");
    const tableSearchSira = ref("");

    const tableEmptySearch = ref(5);
    const tableOptions = ref({
      sortBy: ["id"],
      sortDesc: [true],
    });

    const debouncedTableSearch = useDebounceFn(() => {
      tableFetch();
    }, 700);

    watch(
      [
        tableSearchStatus,
        tableSearchProfile,
        tableSearchUsername,
        tableSearchCustomer,
        tableSearchRootno,
        tableSearchSira,
      ],
      () => {
        loadMoreLoading.value = false;
        tableLoading.value = true;
        tablePage.value = 1;
        tableOptions.value.page = 1;
        tableItems.value = [];

        debouncedTableSearch();
      }
    );

    const phoneNumberFormatView = (phoneNumberString) => {
      let cleaned = ("" + phoneNumberString).replace(/\D/g, "");

      let match = cleaned.match(/^(0|)?(\d{3})(\d{3})(\d{2})(\d{2})$/);

      if (match) {
        let intlCode = match[1] ? "0" : "";
        return [intlCode, match[2], " ", match[3], " ", match[4], " ", match[5]].join("");
      }
      return phoneNumberString;
    };

    const profileList = ref([]);
    const profileFetch = async () => {
      try {
        const data = await postData({
          method: "getProfileList",
        });
        profileList.value = data.detail.map((item) => {
          return {
            value: item.profile_id,
            text: item.profile_name,
          };
        });
      } catch (e) {
        // API hataya girdi
        toast.error(`Hata ${e}`);
      }
    };

    const memberProfile = (item) => {
      let result, color;

      if (item === "SUBE") {
        color = "#463E6A";
      } else if (item === "BAYI") {
        color = "#635997";
      } else if (item === "KURUMSAL") {
        color = "#28243D";
      } else {
        color = "";
      }

      return color;
    };

    const rootInfo = (no, order) => {
      let result, status;
      if (no === null || no == 0 || order === null || order == 0) {
        status = false;
        result = "Tanımsız";
      } else {
        status = true;
        result = `No: ${no} &nbsp;&nbsp; Sıra: ${order}`;
      }

      return [status, result];
    };

    // API İstek
    const tableFetch = async () => {
      tableLoading.value = true;

      postData({
        method: "getMembers",
        options: JSON.stringify(tableOptions.value),
        search: JSON.stringify({
          aktif: tableSearchStatus.value,
          member_profile: tableSearchProfile.value,
          username: tableSearchUsername.value,
          customer_name: tableSearchCustomer.value,
          cari_kod: tableSearchCustomer.value,
          gsm: tableSearchCustomer.value,
          emailto: tableSearchCustomer.value,
          esmroute: tableSearchRootno.value,
          esmrouteseq: tableSearchSira.value,
        }),
      })
        .then(async (response) => {
          // API dönüşündeki hatalara bakıyoruz
          if (response.error) {
            throw new Error(response.msg);
          }

          if (profileList.value.length === 0) {
            await profileFetch();
          }

          // Toplam kayıt sayısı işleniyor
          tableTotalRec.value = Number(response.response.pagination.totalCount);

          // API'dan gelen veriler işleniyor

          // Responseda bir değer yoksa
          if (response.response.result.length === 0) {
            loadMoreLoading.value = false;
            return;
          }

          // Responsedan gelen veriler işleniyor
          response.response.result.map((item) => {
            tableItems.value.push({
              uid: item.uid,
              aktif: item.aktif,
              member_profile: item.member_profile,
              address: item.address?.address ? item.address.address : null,
              member_Txt:
                profileList.value.find((el) => el.value === item.member_profile)?.text ||
                "Tanımsız",
              username: item.username,
              name1: item.name1,
              cari_kod: item.cari_kod,
              telnum: item.telnum,
              mail: item.mail || "tanimsiz@asli.com.tr",
              esmroute: item.esmroute,
              esmrouteseq: item.esmrouteseq,
              emailcc: item.emailcc,
              emailto: item.emailto,
              emailbcc: item.emailbcc,
              ad: item.ad,
              soyad: item.soyad,
              son_giris: item.son_giris,
              adrnums: item.adrnums,
              cashform_branch_name: item.cashform_branch_name,
              cashform_account: item.cashform_account,
              persid: item.persid,
              costcenter: item.costcenter,
            });
          });
          loadMoreLoading.value = false;
          if (tableTotalRec.value >= 20) {
            setTimeout(() => {
              loadMoreLoading.value = true;
            }, 300);
          }
          // Responstan gelen verilere göre loadmore değerlendiriliyor
        })
        .catch((e) => {
          // API hataya girdi
          toast.error(e.message, {
            position: "bottom-center",
          });
        })
        .finally(() => {
          // API işlemi bittikten sonra
          tableLoading.value = false;
        });
    };

    onMounted(() => {
      pageSettings();
      // Kullanıcılar Çekiliyor
      tableFetch();
    });

    onUnmounted(() => {
      pageStore.pageSettingsClear();
    });
    return {
      phoneNumberFormatView,
      rootInfo,
      memberProfile,

      pageStore,

      // Dialog
      profileList,
      userData,
      scrollableEl,
      form,
      saveItem,
      showPassword,
      isScroll,
      arrivedState,

      // Ürün Ekle / Düzenle / Sil
      dialogLoading,
      deleteLoading,
      saveLoading,
      addEditFormTitle,
      addEditdialog,
      editItem,
      deleteItem,
      closeItem,
      saveItem,
      editedItem,
      editedIndex,

      // Table
      tableFetch,
      tableColumns,
      tableItems,
      tableLoading,
      loadMore,
      loadMoreLoading,
      tableTotalRec,
      tableEmptySearch,
      tableOptions,

      // Table Search
      tableSearchStatus,
      tableSearchProfile,
      tableSearchUsername,
      tableSearchCustomer,
      tableSearchRootno,
      tableSearchSira,

      // icons
      icons: {
        mdiCamera,
        mdiCameraOff,
        mdiAccountTie,
        mdiClose,
        mdiMagnify,
        mdiUpload,
        mdiTrashCan,
        mdiCalendarClock,
        mdiPhoneDial,
        mdiQrcode,
        mdiEmail,
      },
    };
  },
};
</script>

<style scoped>
.cari-tip-chip {
  height: auto !important;
  width: 100% !important;
  max-width: 220px !important;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: clip !important;
}

.cari-tip-chip :deep(.v-chip__content),
.cari-tip-chip ::v-deep .v-chip__content {
  white-space: normal !important;
  flex-wrap: wrap !important;
  justify-content: center !important;
  overflow: visible !important;
  text-overflow: clip !important;
}

.cari-tip-text {
  width: 100%;
  max-width: 220px;
  text-align: center;
  font-size: 10px !important;
  letter-spacing: 1.25px;
  color: azure;
  white-space: normal;
  overflow: visible;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 1.2;
}
</style>
